require('src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel.scss');
var ehh = require('src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel-event-handlers-helpers');
var eventHandler = require('src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel-event-handlers');
var filterEvents = require('src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel-filter-events');
var gptSlotIniter = require('src/interlock/product/ads/ad-manager/gpt-slot-initer');
var dependedOnViewportAd = require('src/interlock/product/ads/ad-manager/depended-on-viewport-ad');
var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');
var aagCarouselContent = require('src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel-content');
var isMobile = require('ismobilejs');
var cookies = require('doc-cookies');


var aagCarousel, carouselOwl;
var EVENT_SUBMODEL_CHANGED = 'submodel-changed';
var categoriesLoaded = false;
var OPEN_FILTERS_SLIDE_INDEX = 7;
var web503 = ($('.image-type-selector').data('abtest') === 'web-503');
var opened503 = false;
var triggerToggle;
var closeToggle;
var IS_BTN_CLICK = true;



function init() {
    aagCarousel = document.querySelector('.at-a-glance-carousel-wrapper');
    if (aagCarousel) {
        carouselOwl = aagCarousel.querySelector('.owl-carousel');
        addEventHandlers();
    }
    if(!categoriesLoaded) {
        loadCategories();
    }
    // Back up if 'loaded' event takes too long
    setTimeout(function() {
        if (aagCarousel) {
            aagCarousel.classList.add('loaded');
        }
    }, 5000);
}

function defineTriggerToggle(){
    var openCookie = cookies.getItem('aagFilter');
    if(web503 && !opened503 && !openCookie){
        if(triggerToggle){
            window.clearTimeout(triggerToggle);
        }
        triggerToggle = window.setTimeout(function () {
            opened503 = true;
            if (!aagCarouselContent.isSmall()) {
                filterEvents.toggleFilter(!IS_BTN_CLICK,true);
                closeToggle = window.setTimeout(function () {
                    filterEvents.toggleFilter(false);
                },2000);
            }


        }, 4000);
    }
}

function addEventHandlers() {
    eventToolbox.subscribeCustomEvent(EVENT_SUBMODEL_CHANGED, eventHandler.handleSubmodelChange);

    defineTriggerToggle();

    if(aagCarousel) {

        $(aagCarousel).on('click', function() {
            if(closeToggle){
                window.clearTimeout(closeToggle);
            }
        });

        $(aagCarousel).on('click', '.view-photos', function() {
            $(carouselOwl).trigger('next.owl.carousel');
        });

        $(aagCarousel).on('click', '.filter-btn', function() {
            if(web503){
                window.clearTimeout(triggerToggle);
                opened503 = true;
            }
            filterEvents.fireToggleFilter(IS_BTN_CLICK);
            filterEvents.toggleFilter();
        });

        $(aagCarousel).on('click', '.categories', function(e) {
            eventHandler.handleCategoryChange(e);
            if(web503 && !isMobile.any) {
                filterEvents.toggleFilter();
            }
        });

        $(aagCarousel).on('click', '.filter-close', function() {
            filterEvents.toggleFilter();
        });
    }

    if(isMobile.any) {
        $(document).on('click', filterEvents.closeFilter);
    }


    // Carousel on changed event will handle index switching
    $(carouselOwl).on('changed.owl.carousel', function() {
        ehh.getCurrentDataIndex(function(curIndex) {
            if(OPEN_FILTERS_SLIDE_INDEX === aagCarouselContent.getCurrentSlideIndex() && !aagCarouselContent.isSmall() && !web503) {
                filterEvents.toggleFilter(!IS_BTN_CLICK,true);
            }

            defineTriggerToggle();

            eventHandler.updateIndexes(curIndex, null, null);
            //Update Caption
            eventHandler.populateAltBox(curIndex);
            var indexes = eventHandler.getIndexes();

            // //Append 2 slots before (0, 1, etc - interger scale)
            if (indexes.x - indexes.currentIndex == 1) {
                //console.log('append');
                eventHandler.appendPhotos(indexes.x + 1);
            }
            // Prepend 2 slots before (2 - natural number scale because it's in reverse)
            else if (Math.abs(indexes.y - indexes.currentIndex) == 2) {
                //console.log('prepend');
                eventHandler.appendPhotos(indexes.y - 5, true);
            }
        });
    });

    $(carouselOwl).on('translated.owl.carousel', function(e) {
        var $slide = $(e.target)
            .find('.owl-item')
            .eq(e.item.index);
        dependedOnViewportAd.setSlotIniter(gptSlotIniter);
        dependedOnViewportAd.carouselSlideViewportAdsInView($slide);
    });


    // On carousel load, we want to populate our available categories,
    // this requires a small REST call. We also want to fetch and prepend
    // photos for back button experience.
    window.addEventListener('load', function() {
        // Init some indexes
        if(!categoriesLoaded) {
            loadCategories();
        }

        // backup current slides
        aagCarouselContent.backup('home');
    });

    // START: For AB Test WEB-466
    // We want to auto-open filters after 3 s.
    if($('.image-type-selector')) {
        if($('.image-type-selector').data('abtest') === 'web-466') {
            window.setTimeout(function() {
                if(!aagCarouselContent.isSmall()) {
                    filterEvents.toggleFilter(!IS_BTN_CLICK,true);
                }
            }, 3000);
        }
    }
    // END: For AB Test WEB-466
}

function loadCategories() {
    ehh.getCurrentDataIndex(function(curIndex) {
        eventHandler.updateIndexes(curIndex, 5, null);
    });

    // Initial Prepend some photos in case the user wants to go previous.
    eventHandler.fetchIndexes(function(data) {
        var index = data.totalCounts[0].currentPhotoCount - 5;
        // TODO [FIND-1623] Remove this dataStorage for at-a-glance because
        // we don't want it to fire when it appends photos from the ajax call
        window.EDMDataStorage.aagChangeSlideSkipPixelFire = true;
        categoriesLoaded = true;
        eventHandler.appendPhotos(index, true);
    });
    if (aagCarousel) {
        aagCarousel.classList.add('loaded');
    }
}



init();



//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel.js
// module id = 157
// module chunks = 0 1 27